<template>
  <div>
    <b-row class="">
      <b-col cols="12">
        <b-form-group :label="$lang.name" :label-cols="$config.form.labelCol">
          <!-- <requiredComponent slot="label" :label="$lang.name" :rules="item.name.$params" /> -->
          <b-form-input
            type="text"
            :autocomplete="$lang.name"
            v-model="item.name.$model"
            :state="item.name.$dirty ? !item.name.$error : null"
          >
          </b-form-input>

          <b-form-invalid-feedback
            v-if="!item.name.required"
            id="name-feedback"
          >
            {{ $lang.error_required | replace($lang.name) }}
          </b-form-invalid-feedback>
          <b-form-invalid-feedback
            v-if="item.name.required && !item.name.maxLengh"
            id="name-feedback"
          >
            {{
              $lang.error_max | replace($lang.name, "بین 2 تا 35")
            }}</b-form-invalid-feedback
          >
        </b-form-group>
      </b-col>

      <b-col cols="12">
        <b-form-group
          :label="$lang.family"
          label-for="family"
          :label-cols="$config.form.labelCol"
        >
          <!-- <requiredComponent slot="label" :label="$lang.family" :rules="item.family.$params" /> -->
          <b-form-input
            v-model="item.family.$model"
            :state="item.family.$dirty ? !item.family.$error : null"
            type="text"
            :autocomplete="$lang.family"
          >
          </b-form-input>
          <b-form-invalid-feedback
            v-if="!item.family.required"
            id="family-feedback"
          >
            {{
              $lang.error_required | replace($lang.family)
            }}</b-form-invalid-feedback
          >
          <b-form-invalid-feedback
            v-if="item.family.required && !item.family.maxLengh"
            id="family-feedback"
          >
            {{
              $lang.error_max | replace($lang.family, "بین 3 تا 35")
            }}</b-form-invalid-feedback
          >
        </b-form-group>
      </b-col>
      <b-col cols="12">
        <b-form-group
          :label="$lang.national_code"
          label-for="national_code"
          :label-cols="$config.form.labelCol"
        >
          <!-- <requiredComponent slot="label" :label="$lang.national_code" :rules="item.national_code.$params" /> -->
          <b-form-input
            type="text"
            autocomplete="off"
            :state="
              item.national_code.$dirty ? !item.national_code.$error : null
            "
            v-model="item.national_code.$model"
          >
          </b-form-input>
          <b-form-invalid-feedback id="father_name-feedback">
            {{ $lang.error_required | replace($lang.national_code) }}
          </b-form-invalid-feedback>
          <div class="invalid-feedback" v-if="!item.national_code.numeric">
            {{ $lang.error_numeric | replace($lang.national_code) }}
          </div>
          <div
            class="invalid-feedback"
            v-if="
              item.national_code.numeric &&
              !item.national_code.minLength | !item.national_code.maxLength
            "
          >
            {{ $lang.error_max | replace($lang.national_code, 10) }}
          </div>
        </b-form-group>
      </b-col>

      <b-col cols="12">
        <b-form-group
          :label="$lang.relationship_with_you"
          :label-cols="$config.form.labelCol"
        >
          <!-- <requiredComponent slot="label" :label="$lang.relationship_with_you" 
                    :rules="item.relationship_with_you.$params" />-->
          <!-- <b-form-input type="text" :autocomplete="$lang.relationship_with_you"
                    v-model="item.relationship_with_you.$model"
                    :state="item.relationship_with_you.$dirty ? !item.relationship_with_you.$error : null">
                  </b-form-input> -->
          <selectFind
            :options="relationship_options"
            v-model="item.relationship_with_you.$model"
            label="text"
            :isValid="
              item.relationship_with_you.$dirty
                ? !item.relationship_with_you.$error
                : null
            "
            :loading="relationship_loading"
            :taggable="true"
          />
          <b-form-invalid-feedback
            :style="{
              display: item.relationship_with_you.$error ? 'block' : 'none',
            }"
            id="gender_id-feedback"
          >
            {{
              $lang.error_required | replace($lang.relationship_with_you)
            }}</b-form-invalid-feedback
          >
        </b-form-group>
      </b-col>

      <b-col cols="12">
        <b-form-group
          :label="$lang.birth_date"
          label-for="birth_date"
          :label-cols="$config.form.labelCol"
        >
          <!-- <requiredComponent slot="label" :label="$lang.birth_date" :rules="item.birth_date.$params" /> -->
          <date-picker
            v-model="item.birth_date.$model"
            :state="item.birth_date.$dirty ? !item.birth_date.$error : null"
            format="YYYY/MM/DD"
            display-format="dddd jDD jMMMM jYYYY"
            inputReq="true"
            :clearable="true"
            :class="
              item.birth_date.$dirty
                ? item.birth_date.$error
                  ? 'invalid-date'
                  : 'valid-date'
                : null
            "
          >
          </date-picker>
          <b-form-invalid-feedback
            :style="{ display: item.birth_date.$error ? 'block' : 'none' }"
            id="gender_id-feedback"
          >
            {{
              $lang.error_required | replace($lang.birth_date)
            }}</b-form-invalid-feedback
          >
        </b-form-group>
      </b-col>
      <b-col cols="12">
        <b-form-group
          :label="$lang.mobile"
          label-for="mobile"
          :label-cols="$config.form.labelCol"
        >
          <!-- <requiredComponent slot="label" :label="$lang.mobile" :rules="item.mobile.$params" /> -->
          <b-form-input
            type="text"
            :autocomplete="$lang.mobile"
            placeholder="مثال:09121112233 "
            :state="item.mobile.$dirty ? !item.mobile.$error : null"
            v-model="item.mobile.$model"
          >
          </b-form-input>
          <!-- <small class="form-text text-muted text-left">{{$lang.username}}</small> -->
          <b-form-invalid-feedback id="mobile-feedback"
            >{{ $lang.error_required | replace($lang.mobile) }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>

      <b-col cols="12">
        <b-form-group
          :label="$lang.city_address_home"
          :label-cols="$config.form.labelCol"
        >
          <!-- <requiredComponent slot="label" :label="$lang.city_address_home" :rules="item.location_selected.$params" /> -->
          <selectAsync
            :options="location_options"
            v-model="item.location_selected.$model"
            label="caption"
            :asyncFind="getkind"
            :isValid="
              item.location_selected.$dirty
                ? !item.location_selected.$error
                : null
            "
            :loading="locationLoading"
            :placeholder="$lang.search_city"
          />
          <b-form-invalid-feedback
            :style="{
              display: item.location_selected.$error ? 'block' : 'none',
            }"
            id="gender_id-feedback"
          >
            {{
              $lang.error_required | replace($lang.city_address_home)
            }}</b-form-invalid-feedback
          >
        </b-form-group>
      </b-col>

      <b-col cols="12">
        <b-form-group
          :label="$lang.regional_municipality"
          label-for="regional_municipality"
          :label-cols="$config.form.labelCol"
        >
          <!-- <requiredComponent slot="label" :label="$lang.regional_municipality"
                    :rules="item.regional_municipality.$params" /> -->
          <b-form-input
            type="text"
            :autocomplete="$lang.regional_municipality"
            v-model="item.regional_municipality.$model"
            :state="
              item.regional_municipality.$dirty
                ? !item.regional_municipality.$error
                : null
            "
          >
          </b-form-input>
          <b-form-invalid-feedback id="description-feedback">
            {{ $lang.error_required | replace($lang.regional_municipality) }}
          </b-form-invalid-feedback>
          <b-form-invalid-feedback
            v-if="item.regional_municipality.$error"
            id="name-feedback"
          >
            {{
              $lang.error_Value
                .replace("{0}", $lang.Personal_biography)
                .replace("{1}", "1")
                .replace("{2}", "25")
            }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>

      <b-col cols="12">
        <b-form-group
          :label="$lang.address"
          label-for="address"
          :label-cols="$config.form.labelCol"
        >
          <!-- <requiredComponent slot="label" :label="$lang.address" :rules="item.address.$params" /> -->
          <b-form-input
            type="text"
            v-model="item.address.$model"
            :state="item.address.$dirty ? !item.address.$error : null"
            :autocomplete="$lang.address"
          >
          </b-form-input>
          <!-- <div class="invalid-feedback" v-if="(!item.address.minLengh|!item.address.maxLengh)">
                  {{$lang.error_length| replace($lang.address,10)}}</div> -->
        </b-form-group>
      </b-col>
    </b-row>
    <!--  -->
    <b-button
      v-if="parseInt(item_index) > 0"
      variant="danger"
      class="btn-my-desgin"
      @click="removeColumn(item, item_index)"
    >
      {{ $lang.delete_all_row }}
    </b-button>
  </div>
</template>

<script>
import VuePersianDatetimePicker from "vue-persian-datetime-picker";

export default {
  components: {
    datePicker: VuePersianDatetimePicker,
  },
  props: {
    item_index: {
      type: [String, Number],
    },
    item: {
      type: Object,
    },
    relationship_options: {
      type: Array,
    },
  },
  data() {
    return {
      locationLoading: false,
      location_options: [],
      relationship_loading: false,
    };
  },
  methods: {
    async getkind(query) {
      if (!query || query.length < 2) {
        this.location_options = [];
        return;
      }
      try {
        let url =
          this.$config.api_url +
          this.$config.resources.location +
          `?city=${query}`;
        const response = await this.$httpService.get(url);
        let locations = response.data.data;
        this.location_options = locations;
      } catch (error) {
        this.$generateError(error);
        this.location_options = [];
      }
    },
    removeColumn(item, item_index) {
      this.$emit("removeColumn", item, item_index);
    },
  },
};
</script>
